module.exports = __webpack_public_path__ + "media/new-message.fa72691f.ogg";